export const seoTitle = '联系我们 | 赑玄阁';
export const seoDescription = '赑玄阁联系邮件Email：hello@bixuange.com';
export const browserTitle = '联系我们 | 赑玄阁';
export const keywords = '赑玄阁,  赑玄阁联系,气象仿真, 渲染, 模拟风';
